import React from "react";
import "./accessDenied.css";
import Logo from "../../assets/logotipo - alfa tabelas.png";
import { useNavigate } from "react-router-dom";

/* CONJUNTO DE ICONES */

export default function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="container-message-access-denied">
      <img src={Logo} alt="Logo ALfa Tabelas" />
      {/* <i><MdBlock /></i> */}
      <h1>Acesso Negado</h1>
      <p>Você não tem permissão para acessar esta página.</p>
      <button onClick={() => navigate("/dashboard/")}>
        Voltar ao Dashboard
      </button>
    </div>
  );
}
